import isArrayLikeObject from 'lodash/isArrayLikeObject.js';
import uuid from 'uuid';
import { arrayHasItems } from './helpers.js';
import DateInfo from './date-info.js';

class Attribute {
  constructor(_ref, locale) {
    let {
      key,
      dates,
      excludeDates,
      excludeMode,
      pinPage
    } = _ref;
    this.key = key === undefined ? uuid() : key;
    this.pinPage = pinPage;
    if (dates) {
      this.dates = isArrayLikeObject(dates) ? dates : [dates];
    }
    this.hasDates = arrayHasItems(this.dates);
    if (excludeDates) {
      this.excludeDates = isArrayLikeObject(excludeDates) ? excludeDates : [excludeDates];
    }
    this.hasExcludeDates = arrayHasItems(this.excludeDates);
    this.excludeMode = excludeMode || 'intersects';
    this.dates = (this.hasDates && this.dates || this.hasExcludeDates && [{}] || []).map(d => d && (d instanceof DateInfo ? d : new DateInfo(d, {
      locale
    }))).filter(d => d);
    this.excludeDates = (this.hasExcludeDates && this.excludeDates || []).map(d => d && (d instanceof DateInfo ? d : new DateInfo(d, {
      locale
    }))).filter(d => d);
    this.isComplex = [dates].some(d => d.isComplex);
  }
  intersectsDate(date) {
    return !this.excludesDate(date) && (this.dates.find(d => d.intersectsDate(date)) || false);
  }
  includesDate(date) {
    return !this.excludesDate(date) && (this.dates.find(d => d.includesDate(date)) || false);
  }
  excludesDate(date) {
    return this.hasExcludeDates && this.excludeDates.find(ed => this.excludeMode === 'intersects' && ed.intersectsDate(date) || this.excludeMode === 'includes' && ed.includesDate(date));
  }
  includesDay(day) {
    return !this.excludesDay(day) && (this.dates.find(d => d.includesDay(day)) || false);
  }
  excludesDay(day) {
    return this.hasExcludeDates && this.excludeDates.find(ed => ed.includesDay(day));
  }
}

export { Attribute as default };
//# sourceMappingURL=attribute.js.map
